import { type JSX } from 'react';
import { generatePath } from 'react-router';

import { Link } from 'Components/Buttons/Buttons';
import { Text } from 'Components/Text/Text';
import { ICON_ADD_CREATE } from 'Config/Icons';
import { CREATE_ACTION } from 'Config/PathTemplates';
import { TreatmentPlanStatus } from 'Models/Actions';
import { AssociatedAction } from 'Models/RiskRegister';

import { AssociatedActionListing } from './AssociatedActionListing/AssociatedActionListing';
import styles from './TreatmentPlanListing.module.css';

export interface TreatmentPlanListingProps {
    riskId: string;
    treatmentPlanStatus: TreatmentPlanStatus;
    treatmentPlanDescription?: string;
    actions: AssociatedAction[];
}

export const TreatmentPlanListing = (props: TreatmentPlanListingProps): JSX.Element => {
    return (
        <div className={styles.treatmentPlanTab}>
            <div className={styles.headerContainer}>
                <Text noStyles variant="Header2">
                    Treatment Plan
                </Text>
                <Link variant="primaryButton" to={`${generatePath(CREATE_ACTION)}?riskId=${props.riskId}`} fontAwesomeImage={ICON_ADD_CREATE}>
                    Create Action
                </Link>
            </div>
            <hr />
            <Text noStyles color="darkGray" variant="Header4">
                Status
            </Text>
            <div className={styles.treatmentPlanStatus} data-testid="treatmentPlanStatus">
                <Text noStyles variant="Text2" color="blue">
                    {props.treatmentPlanStatus === TreatmentPlanStatus.MISSING ? '-' : props.treatmentPlanStatus}
                </Text>
            </div>
            <Text noStyles color="darkGray" variant="Header4">
                Description
            </Text>
            <div className={styles.treatmentPlanDescription} data-testid="treatmentPlanDescription">
                <Text noStyles variant="Text2" color="blue">
                    {props.treatmentPlanDescription ?? '-'}
                </Text>
            </div>
            <AssociatedActionListing actions={props.actions} />
        </div>
    );
};
